import React from 'react';

export default {
  svg: (
    <g>
      <g>
        <circle fill="#7CAFD0" strokeWidth={0} cx={39.763} cy={40.442} r={38.5} />
        <path
          fill="#FFFFFF"
          strokeWidth={0}
          d="M39.763,2.942c20.711,0,37.5,16.789,37.5,37.5s-16.789,37.5-37.5,37.5s-37.5-16.789-37.5-37.5 S19.052,2.942,39.763,2.942 M39.763,0.942c-21.78,0-39.5,17.72-39.5,39.5c0,21.78,17.72,39.5,39.5,39.5s39.5-17.72,39.5-39.5 C79.263,18.662,61.543,0.942,39.763,0.942L39.763,0.942z"
        />
      </g>
      <g>
        <defs>
          <circle id="SVGID_19_" cx={39.763} cy={40.442} r={37.5} />
        </defs>
        <clipPath id="SVGID_2_6">
          <use xlinkHref="#SVGID_19_" />
        </clipPath>
        <g clipPath="url(#SVGID_2_6)">
          <polygon
            fill="#32303A"
            strokeWidth={0}
            points="32.225,69.603 47.242,69.603 47.05,75.221 32.371,75.221  "
          />
          <path
            fill="#3C2417"
            strokeWidth={0}
            d="M65.818,44.319c0.219-0.262,0.401-0.554,0.548-0.866c0.485-0.702,0.77-1.553,0.77-2.47 c0-1.591-0.856-2.979-2.129-3.739c0.024-0.188,0.041-0.379,0.041-0.573c0-0.909-0.273-1.753-0.74-2.457 c0.495-0.727,0.785-1.605,0.785-2.551c0-1.888-1.153-3.506-2.792-4.191c0.055-0.273,0.084-0.556,0.084-0.846 c0-1.447-0.719-2.723-1.817-3.5c0.137-0.383,0.216-0.794,0.216-1.224c0-2.008-1.628-3.636-3.636-3.636 c-0.286,0-0.562,0.036-0.829,0.099c-0.484-1.543-1.925-2.663-3.628-2.663c-0.464,0-0.906,0.087-1.317,0.239 c-0.573-1.091-1.713-1.837-3.029-1.844c-0.506-2.154-2.435-3.759-4.743-3.759c-0.326,0-0.643,0.033-0.951,0.094 c-0.885-1.38-2.429-2.297-4.19-2.297c-2.411,0-4.422,1.715-4.879,3.992c-0.929,0.168-1.74,0.669-2.306,1.377 c-0.71-0.604-1.629-0.971-2.635-0.971c-1.587,0-2.958,0.91-3.629,2.235c-2.639,0.026-4.771,2.171-4.771,4.817 c0,0.36,0.043,0.71,0.118,1.048c-1.365,0.44-2.359,1.706-2.359,3.218c0,0.128,0.024,0.249,0.038,0.373 c-1.567,0.438-2.719,1.872-2.719,3.579c0,0.775,0.238,1.494,0.643,2.09c-0.819,0.684-1.341,1.712-1.341,2.863 c0,0.036,0.004,0.071,0.005,0.107c-1.656,0.805-2.799,2.498-2.799,4.463c0,1.432,0.609,2.718,1.579,3.624 c-0.218,0.506-0.339,1.063-0.339,1.649c0,0.982,0.341,1.882,0.908,2.595c-0.443,0.575-0.708,1.292-0.708,2.074 c0,1.039,0.466,1.967,1.2,2.592c-0.214,0.502-0.333,1.055-0.333,1.636c0,1.759,1.088,3.261,2.627,3.878 c-0.112,0.351-0.173,0.724-0.173,1.112c0,1.496,0.899,2.78,2.185,3.348c-0.02,0.154-0.033,0.31-0.033,0.469 c0,2.047,1.66,3.707,3.707,3.707c0.062,0,0.122-0.006,0.183-0.009c0.2,2.287,2.117,4.081,4.455,4.081 c0.277,0,0.547-0.029,0.81-0.077c0.025,1.892,1.565,3.419,3.463,3.419c0.232,0,0.458-0.024,0.676-0.067 c0.698,1.187,1.986,1.987,3.463,1.987c0.701,0,1.36-0.181,1.934-0.496c0.842,0.769,1.959,1.241,3.189,1.241 c2.408,0,4.392-1.798,4.693-4.124c0.814-0.079,1.544-0.443,2.09-0.991c0.618,0.478,1.39,0.765,2.232,0.765 c1.51,0,2.806-0.915,3.364-2.221c0.254,0.045,0.513,0.072,0.78,0.072c2.471,0,4.475-2.003,4.475-4.475 c0-0.164-0.01-0.325-0.027-0.484c1.213-0.621,2.072-1.832,2.195-3.256c1.543-0.697,2.619-2.246,2.619-4.049 c0-0.236-0.024-0.466-0.059-0.692c0.915-0.796,1.496-1.966,1.496-3.275c0-0.134-0.008-0.267-0.02-0.398 c1.502-0.592,2.566-2.052,2.566-3.764C67.022,46.071,66.561,45.053,65.818,44.319z"
          />
          <path
            fill="#BF8858"
            strokeWidth={0}
            d="M54.216,40.782v-6.546c0-6.952-8.048-15.735-14.419-15.735c-6.371,0-14.419,8.783-14.419,15.735v6.546 c-1.77,0-3.204,1.409-3.204,3.147v3.273c0,1.738,1.435,3.147,3.204,3.147c0,4.711,3.697,10.375,8.062,13.539l0,6.73l-3.147,0.67 l3.147,19.868l12.588,0l3.147-19.868l-3.147-0.67v-6.636c4.42-3.146,8.189-8.876,8.189-13.633c1.77,0,3.204-1.409,3.204-3.147 v-3.273C57.42,42.191,55.986,40.782,54.216,40.782z"
          />
          <path
            fill="#B97349"
            strokeWidth={0}
            d="M54.216,40.782v-6.546c0-6.952-8.048-15.735-14.419-15.735v25.491c-2.338,4.883-3.204,10.071-3.204,10.071 l3.204,0.629v11.641c-2.019-0.015-4.202-0.932-6.243-2.398v2.015l12.588,4.428v-6.443c-1.659,1.192-3.411,2.012-5.093,2.29 c6.124-1.048,13.167-9.372,13.167-15.876c1.77,0,3.204-1.409,3.204-3.147v-3.273C57.42,42.191,55.986,40.782,54.216,40.782z  M39.825,66.334c0.069,0,0.139-0.007,0.208-0.009c-0.062,0.002-0.124,0.01-0.185,0.01C39.84,66.336,39.833,66.334,39.825,66.334z  M40.46,66.302c0.164-0.015,0.329-0.036,0.494-0.062C40.789,66.265,40.624,66.287,40.46,66.302z"
          />
          <g>
            <path
              fill="#42404D"
              strokeWidth={0}
              d="M69.439,105.942c-0.094-5.787-0.229-10.366-0.424-12.087c-0.673-5.942-2.155-12.974-7.389-17.998 c-4.502-4.32-9.96-5.16-14.551-5.209l-0.001,0.013c-0.02-0.004-0.038-0.009-0.058-0.013l-4.159,19.11v16.184H69.439z"
            />
            <path
              fill="#42404D"
              strokeWidth={0}
              d="M32.451,70.649L32.451,70.649L32.451,70.649L32.451,70.649c-4.592,0.049-10.049,0.888-14.551,5.209 c-5.234,5.023-6.716,12.056-7.389,17.998c-0.195,1.721-0.33,6.3-0.424,12.087H36.61V89.758L32.451,70.649L32.451,70.649z"
            />
          </g>
          <g>
            <polygon
              fill="#32303A"
              strokeWidth={0}
              points="24.853,74.638 31.912,77.247 29.141,81.024 36.586,89.758 32.225,69.603  "
            />
            <polygon
              fill="#32303A"
              strokeWidth={0}
              points="54.613,74.638 47.242,69.603 42.856,89.758 50.325,81.024 47.555,77.247  "
            />
          </g>
          <g>
            <g>
              <path
                fill="#AC6640"
                strokeWidth={0}
                d="M34.413,44.952c0.048,1.372-1.025,2.523-2.397,2.571c-1.372,0.048-2.523-1.025-2.571-2.397 c-0.048-1.372,1.025-2.523,2.397-2.571C33.214,42.506,34.366,43.58,34.413,44.952z"
              />
              <path
                fill="#3C2417"
                strokeWidth={0}
                d="M34.413,44.322c0.048,1.372-1.025,2.523-2.397,2.571c-1.372,0.048-2.523-1.025-2.571-2.397 c-0.048-1.372,1.025-2.523,2.397-2.571C33.214,41.877,34.366,42.95,34.413,44.322z"
              />
              <path
                fill="#FFFFFF"
                strokeWidth={0}
                d="M33.394,43.612c0.012,0.343-0.256,0.631-0.599,0.643c-0.343,0.012-0.631-0.256-0.643-0.599 c-0.012-0.343,0.256-0.631,0.599-0.643C33.094,43,33.382,43.269,33.394,43.612z"
              />
              <path
                fill="#3C2417"
                strokeWidth={0}
                d="M34.953,42.423c-0.458-1.065-1.633-1.873-2.924-2.01c-0.791-0.086-2.275,0.031-3.551,1.646 c-0.061,0.005-0.117,0.007-0.188-0.001c-0.142-0.012-0.339-0.059-0.531-0.141c-0.392-0.158-0.717-0.487-0.717-0.487 c-0.023-0.022-0.059-0.03-0.089-0.015c-0.039,0.019-0.055,0.065-0.036,0.104c0,0,0.049,0.108,0.143,0.263 c0.092,0.156,0.238,0.358,0.423,0.535c0.183,0.178,0.402,0.329,0.586,0.42c0.091,0.047,0.175,0.079,0.236,0.101 c0.059,0.021,0.121,0.033,0.111,0.031c0.172,0.017,0.328-0.075,0.403-0.219c0.835-1.167,1.952-1.74,3.145-1.612 c1.054,0.112,2.046,0.784,2.412,1.633c0.07,0.16,0.255,0.233,0.414,0.165C34.947,42.768,35.021,42.583,34.953,42.423z"
              />
            </g>
            <g>
              <path
                fill="#A15333"
                strokeWidth={0}
                d="M50.149,44.952c0.048,1.372-1.025,2.523-2.397,2.571c-1.372,0.048-2.523-1.025-2.571-2.397 c-0.048-1.372,1.025-2.523,2.397-2.571C48.95,42.506,50.101,43.58,50.149,44.952z"
              />
              <path
                fill="#3C2417"
                strokeWidth={0}
                d="M50.149,44.322c0.048,1.372-1.025,2.523-2.397,2.571c-1.372,0.048-2.523-1.025-2.571-2.397 c-0.048-1.372,1.025-2.523,2.397-2.571C48.95,41.877,50.101,42.95,50.149,44.322z"
              />
              <path
                fill="#FFFFFF"
                strokeWidth={0}
                d="M49.129,43.612c0.012,0.343-0.256,0.631-0.599,0.643c-0.343,0.012-0.631-0.256-0.643-0.599 c-0.012-0.343,0.256-0.631,0.599-0.643C48.83,43,49.117,43.269,49.129,43.612z"
              />
              <path
                fill="#3C2417"
                strokeWidth={0}
                d="M44.641,42.423c0.459-1.065,1.633-1.873,2.924-2.01c0.791-0.086,2.275,0.031,3.551,1.646 c0.061,0.005,0.117,0.007,0.188-0.001c0.142-0.012,0.339-0.059,0.531-0.141c0.392-0.158,0.717-0.487,0.717-0.487 c0.023-0.022,0.059-0.03,0.089-0.015c0.039,0.019,0.055,0.065,0.036,0.104c0,0-0.049,0.108-0.143,0.263 c-0.092,0.156-0.238,0.358-0.423,0.535c-0.183,0.178-0.402,0.329-0.586,0.42c-0.091,0.047-0.175,0.079-0.236,0.101 c-0.059,0.021-0.121,0.033-0.111,0.031c-0.171,0.017-0.328-0.075-0.403-0.219c-0.835-1.167-1.952-1.74-3.145-1.612 c-1.054,0.112-2.046,0.784-2.412,1.633c-0.07,0.16-0.255,0.233-0.414,0.165C44.646,42.768,44.572,42.583,44.641,42.423z"
              />
            </g>
          </g>
          <g>
            <path
              fill="#F05D44"
              strokeWidth={0}
              d="M44.832,57.017c0,2.472-2.254,4.476-5.035,4.476s-5.035-2.004-5.035-4.476H44.832z"
            />
            <path
              fill="#FFFFFF"
              strokeWidth={0}
              d="M43.308,58.695h-7.133c-0.348,0-0.629-0.282-0.629-0.629v-1.049h8.392v1.049 C43.938,58.413,43.656,58.695,43.308,58.695z"
            />
          </g>
          <g>
            <path
              fill="#F05D44"
              strokeWidth={0}
              d="M24.748,53.629c-0.348,0-0.629-0.282-0.629-0.629v-2.651c0-0.348,0.282-0.629,0.629-0.629 c0.348,0,0.629,0.282,0.629,0.629V53C25.378,53.347,25.096,53.629,24.748,53.629z"
            />
            <path
              fill="#F05D44"
              strokeWidth={0}
              d="M54.846,53.629c-0.348,0-0.629-0.282-0.629-0.629v-2.651c0-0.348,0.282-0.629,0.629-0.629 c0.348,0,0.629,0.282,0.629,0.629V53C55.475,53.347,55.193,53.629,54.846,53.629z"
            />
          </g>
          <path
            fill="#3C2417"
            strokeWidth={0}
            d="M60.56,28.868c0.458-0.611,0.733-1.368,0.733-2.19c0-0.736-0.219-1.42-0.594-1.994 c0.507-0.64,0.811-1.448,0.811-2.328c0-1.787-1.249-3.28-2.92-3.662c-0.291-0.193-0.618-0.33-0.962-0.426 c0.097-0.33,0.151-0.677,0.151-1.038c0-2.03-1.646-3.675-3.675-3.675c-0.916,0-1.752,0.337-2.395,0.891 c-0.549-1.753-2.185-3.025-4.119-3.025c-2.383,0-4.315,1.932-4.315,4.315c0,0.681,0.162,1.322,0.442,1.894 c-0.452,0.111-0.871,0.305-1.238,0.568c0.001-0.043,0.006-0.085,0.006-0.128c0-1.273-0.613-2.399-1.556-3.111 c0.027-0.192,0.046-0.387,0.046-0.586c0-2.289-1.856-4.146-4.146-4.146c-0.078,0-0.154,0.007-0.231,0.012 c-0.34-0.073-0.693-0.113-1.055-0.113c-1.285,0-2.454,0.487-3.343,1.281c-2.037,0.196-3.63,1.91-3.634,3.997 c-1.213,0.133-2.237,0.888-2.752,1.938c-1.166,0.717-1.947,2.001-1.949,3.47c-1.458,0.494-2.508,1.871-2.508,3.496 c0,0.305,0.041,0.599,0.11,0.882c-0.871,0.843-1.415,2.022-1.415,3.33c0,1.593,0.804,2.998,2.029,3.832 c-0.033,0.224-0.055,0.452-0.055,0.686c0,2.609,2.115,4.723,4.724,4.723c1.27,0,2.421-0.504,3.27-1.32 c1.334-0.269,2.388-1.305,2.69-2.627c0.016,0,0.032,0.002,0.049,0.002c2.001,0,3.624-1.622,3.624-3.624 c0-0.021-0.003-0.041-0.003-0.062c1.157-0.322,2.085-1.186,2.496-2.303c0.177-0.04,0.35-0.09,0.52-0.149 c0.695,1.775,2.415,3.036,4.434,3.048c0.183,1.826,1.724,3.251,3.598,3.251c0.109,0,0.217-0.007,0.323-0.016 c-0.017,0.143-0.028,0.288-0.028,0.436c0,2.053,1.664,3.717,3.717,3.717c1.379,0,2.58-0.753,3.222-1.868 c0.862,0.87,2.057,1.409,3.378,1.409c2.627,0,4.757-2.13,4.757-4.757C62.796,31.197,61.901,29.71,60.56,28.868z"
          />
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 80 80'
};
